import Empty from 'constants/empty';

const beautyInsiderSelector = store => store.beautyInsider || Empty.Object;

export default { beautyInsiderSelector };
